import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-is-default-checkbox',
    template: `
        <input type="checkbox"
            [checked]="value"
            (change)="onCheckboxChange($event)" class="form-check-input">
    `
})
export class IsDefaultCheckBoxComponent {
    @Input()
    data: any = {};
    public value: boolean; 

    @Output() emitter: Subject<{isChecked: boolean, data: any}> = new Subject<{isChecked: boolean, data: any}>();

    public ngOnInit() {
        this.value = this.data.isDefault;
    }

    onCheckboxChange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.emitter.next({
            isChecked: isChecked,
            data: this.data
        });
    }
}
